/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Waterdefect1Inputs */



/**
* | output |
* | --- |
* | "Water defect" |
*
* @param {Br_History_Key_Waterdefect1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_waterdefect1 = /** @type {((inputs?: Br_History_Key_Waterdefect1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Waterdefect1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Water defect")
	return /** @type {LocalizedString} */ ("Défaut d'eau")
});
export { br_history_key_waterdefect1 as "br_history_key_waterDefect" }